import script from "./ProfileEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&setup=true&lang=js"

import "./ProfileEdit.vue?vue&type=style&index=0&id=07b7e90b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b7e90b"]])

export default __exports__